<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Labs</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- PORTFOLIO 2 COLUMNS
================================================== -->
<section>
    <div class="container">
        <div class="section-heading">
            <span class="sub-title">Labs</span>
            <h2 class="h1 mb-0">ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h2>
        </div>
        <div class="row mt-n1-9 portfolio-gallery">
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool05/6.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL OF ALLIED HEALTH SCIENCES / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool05/2.jpeg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool05/3.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL OF ALLIED HEALTH SCIENCES / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool05/3.jpeg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool05/4.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL OF ALLIED HEALTH SCIENCES / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool05/4.jpeg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool05/5.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL OF ALLIED HEALTH SCIENCES / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool05/5.jpeg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool05/6.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL OF ALLIED HEALTH SCIENCES / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool05/6.jpeg" alt="...">
                </div>
            </div>
            <div class="col-md-6 mt-1-9" data-src="assets/img/ArniSchool05/7.jpeg"
                 data-sub-html="<h4 class='text-white'>ARNI SCHOOL OF ALLIED HEALTH SCIENCES / LABS</h4>">
                <div class="portfolio-wrapper">
                    <img class="border-radius-3 cursor-pointer cover-background w-100 h-100"
                         src="assets/img/ArniSchool05/7.jpeg" alt="...">
                </div>
            </div>
        </div>
    </div>
</section>
